export const GET_REINSURERS = "GET_REINSURERS";
export const GET_REINSURER = "GET_REINSURER";
export const UPDATE_REINSURERS = "UPDATE_REINSURERS";
export const SELECT_REINSURER = "SELECT_REINSURER";
export const REMOVE_REINSURER = "REMOVE_REINSURER";
export const UPDATE_REINSURER_OFFERS = "UPDATE_REINSURER_OFFERS";
export const UPDATE_REINSURER_TREATIES = "UPDATE_REINSURER_TREATIES";
export const CHANGE_REINSURER_PAGE_TYPE = "CHANGE_REINSURER_PAGE_TYPE";